<form #form="ngForm" class="lead-pre-insert-form" novalidate>
    <!-- Pessoa Exterior -->
    <div class="row" *ngIf="config?.podeCadastrarLeadExterior">
        <div class="form-group col-12">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.exterior" name="exterior" id="exterior">
                <label class="custom-control-label" for="exterior">Lead do exterior?</label>
            </div>
        </div>
    </div>

    <!-- Origem -->
    <div class="row" *ngIf="isShowOrigem">
        <div class="form-group col-12 col-xl">
            <label for="origem" class="col-form-label">Qual a origem deste lead?</label>
            <sgt-origem-select
                #origemSelect
                [idOrigem]="entity.origem"
                (idOrigemChange)="onChangeOrigem($event)"
                [required]="true">
            </sgt-origem-select>
            <div class="form-text text-muted">Origem que gerou este lead</div>
        </div>

        <!-- Canal de Venda de Origem -->
        <div class="form-group col-12 col-xl" *ngIf="entity.isOrigemPossuiCanalVenda()">
            <label class="col-form-label">Canal de Venda de Origem</label>
            <sgt-canal-venda-select
                #canalVendaOrigemSelect
                [(idCanalVenda)]="entity.idCanalVendaOrigem"
                [(canalVenda)]="entity.canalVendaOrigem"
                [required]="true">
            </sgt-canal-venda-select>
            <p class="form-text text-muted">
                Canal de venda que originou este lead
            </p>
        </div>
        
        <!-- Canal de Mídia Social -->
        <div class="form-group col-12 col-xl" *ngIf="entity.isOrigemMidiaSocial()">
            <label for="canalMidiaSocial" class="col-form-label">Qual o canal da mídia social?</label>
            <sgt-canal-midia-social-select
                #canalMidiaSocialSelect
                [idCanalMidiaSocial]="entity.canalMidiaSocial"
                (idCanalMidiaSocialChange)="entity.canalMidiaSocial = $event"
                name="canalMidiaSocial"
                id="canalMidiaSocial"
                [required]="true">
            </sgt-canal-midia-social-select>
            <div class="form-text text-muted">Canal da mídia social que originou este lead</div>             
        </div>         
    </div> 
    
    <!-- Campanha de Origem -->
    <div class="row" *ngIf="entity.isOrigemCampanha()">
        <div class="form-group col-12">
            <label for="campanhaOrigem" class="col-form-label">Qual a campanha de lead?</label>                            
            <sgt-campanha-select
                #campanhaOrigemSelect
                [(ngModel)]="entity.idCampanhaOrigem"
                [campanha]="entity.campanhaOrigem"
                (campanhaChange)="onChangeCampanhaOrigem($event)"
                name="campanhaOrigem"
                id="campanhaOrigem"
                #campanhaOrigemModel="ngModel"
                required="required"
                [somenteEmAndamento]="true"
                [objetivoAquisicao]="true">
            </sgt-campanha-select>
            <div class="form-text text-muted">
                Campanha que originou este lead
            </div>
            <sgt-form-control-error
                *ngIf="campanhaOrigemModel.errors && campanhaOrigemModel.errors.required && campanhaOrigemModel.dirty"
                msgError="A campanha de origem é obrigatória">
            </sgt-form-control-error>               
        </div>
    </div>    
    
    <div class="row">
        <div class="form-group col-12 col-md" *ngIf="isShowUsuarioResponsavel">
            <label for="usuarioResponsavel" class="col-form-label">Responsável</label>
            <sgt-usuario-select
                #usuarioSelect
                [idUsuario]="entity.idUsuarioResponsavel"
                (usuarioChange)="onChangeUsuarioResponsavel($event)"
                empityName="Nenhum responsável">
            </sgt-usuario-select>                            
            <p class="form-text text-muted">Usuário responsável pelo Lead</p>                
        </div>
        <div class="form-group col-12 col-md" *ngIf="isShowTemperatura">
            <label for="temperatura" class="col-form-label">Temperatura</label>
            <sgt-temperatura-select
                [(idTemperatura)]="entity.temperatura">
            </sgt-temperatura-select>
        </div>
    </div>    

    <div class="row">
        <div class="form-group col-12">
            <label for="tipoPessoa" class="col-form-label">Qual o tipo do lead?</label>
            <sgt-pessoa-tipo-card-control-radio
                [ngModel]="entity.tipoPessoa"
                (ngModelChange)="onChangeTipoPessoa($event)"
                name="tipoPessoa"
                id="tipoPessoa"
                required="required"
                msgErrorRequired="O tipo do lead é obrigatório"
                [isShowCentralCompras]="false">
            </sgt-pessoa-tipo-card-control-radio>
        </div>              
    </div>

    <div class="row">
        <div class="form-group col-12 col-md-4" *ngIf="entity.isTipoPessoaFisicaOuJuridica()">
            <label for="cnpjCpf" class="col-form-label">{{entity.tipoPessoa | pessoaTipoAbreviacao}}</label>
            <input type="text" class="form-control" [(ngModel)]="entity.cnpjCpf" name="cnpjCpf" id="cnpjCpf"
                #cnpjCpf="ngModel" #cnpjCpfInput [required]="isCnpjCpfRequired()"
                [ngControl]="cnpjCpf" [sgtCnpjCpf]="entity.tipoPessoa" [isValidate]="mustValidateCnpjCpf()" [isApplyMask]="!entity.exterior">
                <label class="col-form-label ignorar-cnpj-cpf-invalido" *ngIf="usuarioPodeSalvarCnpjCpfInvalido">
                    <input type="checkbox" [(ngModel)]="ignorarCnpjCpfInvalido" name="ignorarCnpjCpfInvalido" id="ignorarCnpjCpfInvalido" tabindex="-1">
                    Ignorar {{entity.tipoPessoa | pessoaTipoAbreviacao}} inválido
                </label>                
            <sgt-form-control-error
                *ngIf="cnpjCpf.errors && cnpjCpf.errors.required && cnpjCpf.dirty"
                msgError="O {{entity.tipoPessoa | pessoaTipoAbreviacao}} é obrigatório">
            </sgt-form-control-error>
            <sgt-form-control-error
                *ngIf="cnpjCpf.errors && cnpjCpf.errors.cnpjCpfInvalido"
                msgError="{{entity.tipoPessoa | pessoaTipoAbreviacao}} inválido">
            </sgt-form-control-error>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-12">
            <label for="nome" class="col-form-label">Nome</label>
            <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                #nome="ngModel" #nomeInput required="required" maxlength="255" sgtUppercase>
            <sgt-form-control-error
                *ngIf="nome.errors && nome.errors.required && nome.dirty"
                msgError="O nome é obrigatório">
            </sgt-form-control-error>
            <sgt-form-control-error
                *ngIf="nome.errors && nome.errors.maxlength"
                msgError="O nome deve ter no máximo 255 caracteres">
            </sgt-form-control-error>
        </div>
    </div>    

    <div class="row">
        <div class="col-12">
            <button type="button" class="btn btn-primary" #btnConfirm (click)="confirmClick()">
                Avançar <i class="fas fa-arrow-right"></i>
            </button>
        </div>
    </div>
</form>